import { useLocations } from '@services/common/useLocation'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Combobox, ComboboxOption } from '@/components/ui/combobox'

// Flatten the location tree to leaf options ("Village, District").
function flattenLocations(nodes: any[], parent = ''): ComboboxOption[] {
  const out: ComboboxOption[] = []
  for (const node of nodes ?? []) {
    const children = node?.children as any[] | undefined
    if (Array.isArray(children) && children.length > 0) {
      out.push(...flattenLocations(children, node.title))
    } else if (node?.value) {
      out.push({
        value: String(node.value),
        label: parent ? `${node.title}, ${parent}` : node.title
      })
    }
  }
  return out
}

interface Props {
  value?: string
  onChange: (value: string | undefined) => void
  invalid?: boolean
  disabled?: boolean
}

export function FlatLocationField({
  value,
  onChange,
  invalid,
  disabled
}: Props) {
  const { t } = useTranslation('layout')
  const { data: locations, isLoading } = useLocations()

  const options = useMemo(
    () => flattenLocations((locations as any[]) ?? []),
    [locations]
  )

  return (
    <Combobox
      clearable
      loading={isLoading}
      disabled={disabled}
      value={value}
      invalid={invalid}
      onChange={onChange}
      placeholder={t('common.select_location')}
      options={options}
    />
  )
}
